import { render, staticRenderFns } from "./PickPopup.vue?vue&type=template&id=b5640d0e&scoped=true&"
import script from "./PickPopup.vue?vue&type=script&lang=js&"
export * from "./PickPopup.vue?vue&type=script&lang=js&"
import style0 from "./PickPopup.vue?vue&type=style&index=0&id=b5640d0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5640d0e",
  null
  
)

export default component.exports